import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import DevelopmentSiteEditPage from '../components/DevelopmentSiteEditPage'
import {
  actionCreators,
  IDevelopmentSiteEditState,
  selectError,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectNewTeamMembers,
  selectNewTeamName,
  selectShowTeamModal,
  selectSite,
} from '../modules/developmentSiteEdit'

export default connect(
  createStructuredSelector<ApplicationState, IDevelopmentSiteEditState>({
    error: selectError(),
    isLoading: selectIsLoading(),
    isReady: selectIsReady(),
    isSaving: selectIsSaving(),
    newTeamMembers: selectNewTeamMembers(),
    newTeamName: selectNewTeamName(),
    showTeamModal: selectShowTeamModal(),
    site: selectSite(),
  }),
  actionCreators,
)(DevelopmentSiteEditPage)
